/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import { Box, Button, Grid, Paper, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'
import { ArrowLeft } from 'react-feather'
import { useTranslation } from 'react-i18next'

import ExcelLogo from '../../../../assets/images/learnstage-logo.png'
import { ROUTES } from '../../../../helpers/constants'
import { noop } from '../../../../helpers/utils'
import withRedirect from '../../../../hocs/RedirectHOC'
import Breadcrumb from '../../../breadcrumbs/SimpleBreadcrumbs'
import SelectFilter from '../../../filters/SelectDropDown'
import AvailableProgramsList from './AvailableProgramsList'

function AvailablePrograms({
  pageDetails,
  availableProgramList,
  onChangePage,
  filter,
  setFilterValue,
  programCategoryList,
  user,
  enrollProgram,
  school,
  readOnlyMode,
  metadata,
  redirectToPrograms,
}) {
  const { t } = useTranslation()

  const breadcrumbData = [
    {
      title: t('breadcrumbSIS'),
      href: ROUTES.DASHBOARD,
    },
    {
      title: t('otherPrograms'),
      href: '',
    },
  ]
  const ButtonEnhanced = withRedirect(Button)
  return (
    <>
      {!readOnlyMode ? (
        <Box py={2}>
          <Breadcrumb data={breadcrumbData} />
          <Typography component="h4" align="left" variant="h5" color="textPrimary" tabIndex={0}>
            <Box component="span" fontWeight="700">
              {t('otherPrograms')}
            </Box>
          </Typography>
        </Box>
      ) : (
        <Box
          pb={2}
          px={3}
          display="flex"
          alignItems="flex-start"
          justifyContent="flex-start"
          flexDirection="column"
        >
          <Box
            width="100%"
            flexGrow={0}
            display="flex"
            alignItems="center"
            justifyContent={{ xs: 'center', md: 'space-between' }}
            flexDirection="row"
            px={0}
            py={2}
            className="allProgmResvi-between"
          >
            <Box className="brand-logo">
              <img
                src={school.sch_logo || ExcelLogo}
                alt="Logo"
                onError={(e) => {
                  e.target.onerror = null
                  e.target.src = ExcelLogo
                }}
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              flexDirection="row"
              fontWeight="fontWeightMedium"
              fontSize="14px"
            >
              {!window.location.pathname.includes('/accessibleprograms') && (
                <ButtonEnhanced
                  className="custom-default-button text-transform-none"
                  size="large"
                  variant="contained"
                  disableElevation
                  to={`${ROUTES.REGISTER}`}
                  // search={`?pid=${pid}`}
                >
                  {t('registerNow')}
                </ButtonEnhanced>
              )}
              <Box ml={1}>
                <ButtonEnhanced
                  className="custom-default-button text-transform-none"
                  variant="contained"
                  size="large"
                  disableElevation
                  to={ROUTES.LOGIN}
                  startIcon={<ArrowLeft width={16} height={16} />}
                >
                  {t('back')}
                </ButtonEnhanced>
              </Box>
            </Box>
          </Box>
          <Typography component="h4" align="left" variant="h5" color="textPrimary" tabIndex={0}>
            <Box component="span" fontWeight="700">
              {t('allPrograms')}
            </Box>
          </Typography>
        </Box>
      )}
      <Box px={readOnlyMode ? 3 : 0}>
        <Paper rounded="true" elevation={1} className="paper-round">
          {!readOnlyMode && (
            <Box pt={1} pl={3} display="flex" width="100%" alignItems="center" flexDirection="row">
              <Typography
                component="h4"
                align="left"
                variant="h6"
                color="textPrimary"
                gutterBottom
                tabIndex={0}
              >
                <Box component="span" fontWeight="fontWeightMedium" fontSize="16px">
                  {t('filterBy')}:
                </Box>
              </Typography>
              <Box pl={2}>
                <Grid container>
                  <Grid item xs={12} className="availablePrograms-tour-step0" sm="auto">
                    <SelectFilter
                      name="programCategory"
                      filter={filter}
                      setFilterValue={setFilterValue}
                      labelFallback={t('fields:allCategories')}
                      optionId="pct_id"
                      optionName="pct_name"
                      options={programCategoryList}
                      dropdownWidth="enroll-category"
                    />
                  </Grid>
                </Grid>
              </Box>
            </Box>
          )}
          <Box p={{ xs: 0, sm: 3 }}>
            <AvailableProgramsList
              availableProgramList={availableProgramList}
              pageDetails={pageDetails}
              onChangePage={onChangePage}
              user={user}
              enrollProgram={enrollProgram}
              readOnlyMode={readOnlyMode}
              metadata={metadata}
              redirectToPrograms={redirectToPrograms}
            />
          </Box>
        </Paper>
      </Box>
    </>
  )
}
AvailablePrograms.propTypes = {
  availableProgramList: PropTypes.array,
  pageDetails: PropTypes.object,
  onChangePage: PropTypes.func,
  filter: PropTypes.object,
  setFilterValue: PropTypes.func,
  programCategoryList: PropTypes.array,
  user: PropTypes.object,
  enrollProgram: PropTypes.func,
  school: PropTypes.object,
  readOnlyMode: PropTypes.bool,
  metadata: PropTypes.object,
  redirectToPrograms: PropTypes.func,
}

AvailablePrograms.defaultProps = {
  availableProgramList: [],
  pageDetails: {},
  onChangePage: noop,
  filter: {},
  setFilterValue: noop,
  programCategoryList: [],
  user: {},
  enrollProgram: noop,
  school: {},
  readOnlyMode: false,
  metadata: {},
  redirectToPrograms: noop,
}

export default AvailablePrograms
